module.exports = __webpack_public_path__ + "img/58.5.COD.5835cc25.png";